import axios from "axios";

export const loginAuthentication = async (credentials) => {
  const data = JSON.stringify({
    email: credentials.email,
    password: credentials.password,
  });
  const url = window.location.hostname.includes("localhost")
  ? "localhost"
  : "unioninformatica.org";

  const config = {
    method: "POST",
    url: `http://${url}:4000/api/v1/boletaDigital/loginAuthentication`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response = axios(config);
    return await response;
  } catch (error) {
    const { response } = error;
    return await response;
  }
};
